var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89174 12.8464L14.3917 5.34644L13.2199 4.1355L6.89174 10.4636L3.92299 7.49487L2.75112 8.66675L6.89174 12.8464ZM2.67299 2.80737C4.31362 1.16675 6.27976 0.346437 8.57143 0.346437C10.8631 0.346437 12.8162 1.16675 14.4308 2.80737C16.0714 4.42196 16.8917 6.37508 16.8917 8.66675C16.8917 10.9584 16.0714 12.9246 14.4308 14.5652C12.8162 16.1798 10.8631 16.9871 8.57143 16.9871C6.27976 16.9871 4.31362 16.1798 2.67299 14.5652C1.05841 12.9246 0.251117 10.9584 0.251117 8.66675C0.251117 6.37508 1.05841 4.42196 2.67299 2.80737Z",
    fill: "#007C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.815dbe6d953a9331d9fc0127d72ac823.svg";
export { ForwardRef as ReactComponent };